import React, { useContext } from "react";
import { Box, HStack, Icon, IconButton, useBoolean } from "@chakra-ui/react";
import HoneyIcon from "components/HoneyIcon";
import WalletAsset from "components/WalletAsset";
import useAssets from "hooks/useAssets";
import EtherAmount from "components/EtherAmount";
import CurrencySelect from "components/CurrencySelect";
import CurrencyContext from "contexts/CurrencyContext";
import { Currency } from "types";
import EthIcon from "components/EthIcon";
import { FaInfoCircle } from "react-icons/fa";
import HoneyBalancePopup from "components/HoneyBalancePopup";
import useHoneyOwnedTotal from "hooks/useHoneyOwnedTotal";

const WalletAssetsContainer = () => {
  const { currency, changeCurrency } = useContext(CurrencyContext);
  const { balance } = useAssets();
  const honeyTotalBalance = useHoneyOwnedTotal();
  const [isHoneyBalancePopupVisible, setIsHoneyBalancePopupVisible] =
    useBoolean();

  return (
    <>
      <HStack justify="stretch" spacing={3}>
        <WalletAsset
          py="4"
          icon={currency === Currency.Honey ? HoneyIcon : EthIcon}
          value={
            currency === Currency.Honey ? (
              <EtherAmount amount={honeyTotalBalance} />
            ) : (
              <EtherAmount amount={balance} />
            )
          }
        >
          <HStack spacing="1">
            {currency === Currency.Honey && (
              <IconButton
                aria-label=""
                size="sm"
                variant="ghost"
                icon={<Icon w="5" h="5" as={FaInfoCircle} />}
                onClick={() => setIsHoneyBalancePopupVisible.on()}
              />
            )}

            <Box w="32" pr="3">
              <CurrencySelect
                currency={currency}
                onChange={(currency) => changeCurrency(currency)}
              />
            </Box>
          </HStack>
        </WalletAsset>
      </HStack>

      {isHoneyBalancePopupVisible && (
        <HoneyBalancePopup isOpen onClose={setIsHoneyBalancePopupVisible.off} />
      )}
    </>
  );
};

export default WalletAssetsContainer;
